import { State, Action } from './types'

function assertNever(state: State, _: never) {
  return state
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'setSelectedRows': {
      return {
        ...state,
        selectedRows: action.payload,
      }
    }
    default:
      return assertNever(state, action as never)
  }
}

export const initialState = {
  selectedRows: {},
  gridRef: null,
}
